import { Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { SessionExpiredService } from './session-expired.service';

@Injectable()
export class AuthExpiredInterceptor implements HttpInterceptor {
  constructor(private sessionExpiredService: SessionExpiredService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (this.isExpiredAuthError(error)) {
          this.sessionExpiredService.notifySessionExpired();
        }

        return throwError(error);
      })
    );
  }

  private isExpiredAuthError(error: HttpErrorResponse): boolean {
    if (error.status !== 401 || !localStorage.getItem('authToken')) {
      return false;
    }

    const message = (error.error && error.error.message ? error.error.message : '').toString().toLowerCase();
    return message.includes('authentication token') || message.includes('token has been expired') || message.includes('login again');
  }
}
